import { render, staticRenderFns } from "./TermsLists.vue?vue&type=template&id=736a1f76&scoped=true&"
import script from "./TermsLists.vue?vue&type=script&lang=js&"
export * from "./TermsLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a1f76",
  null
  
)

export default component.exports